export const isQuestionRequired = (question = {}) => {
  const candidates = [
    question.validation?.required,
    question.validation_rules?.required,
    question.is_required,
    question.required,
  ];

  const configured = candidates.find(
    (candidate) => candidate !== undefined && candidate !== null
  );
  return configured === undefined ? false : Boolean(configured);
};

export const isEmptyQuestionResponse = (responseValue) => {
  if (responseValue === undefined || responseValue === null) return true;
  if (typeof responseValue === "string") return responseValue.trim() === "";
  if (Array.isArray(responseValue)) return responseValue.length === 0;
  return false;
};

export const requiredGroupedFieldError = (
  question = {},
  responseValue,
  subQuestions = question.sub_questions || [],
) => {
  const values = responseValue && typeof responseValue === "object"
    ? responseValue
    : {};
  const missingQuestion = subQuestions.find((subQuestion) => (
    isQuestionRequired(subQuestion)
    && isEmptyQuestionResponse(values[subQuestion.id])
  ));

  return missingQuestion
    ? `${missingQuestion.question_text || "This field"} is required`
    : "";
};
